// extracted by mini-css-extract-plugin
export default {"main-content":"App_main-content__cO4Ec"};